import styled from 'styled-components';

export default styled.div`
  font-family: 'Graphik LC', sans-serif;
  font-size: 15px;
  line-height: 1.47;
  text-align: center;
  color: ${({color}) => color ? color : '#151515'};
`;